<template>
  <div id="app">
	<home/>
  </div>
</template>

<script>
import Home from "@/views/Home.vue";
export default {
	components: {
		Home
	}
}
</script>


<style lang="scss">
body{
	height: 100%;
	margin: 0px;
	padding: 0px;
}

#app {
	position: fixed;
	width: 100%;
	height: 100%;
	background-color: rgb(100, 100, 100);
	font-family: 'Avenir', Helvetica, Arial, sans-serif;
	-webkit-font-smoothing: antialiased;
	-moz-osx-font-smoothing: grayscale;
	color: #2c3e50;
	overflow-y: auto;
}
#nav {
	padding: 30px;
	a {
		font-weight: bold;
		color: #2c3e50;
		&.router-link-exact-active {
			color: #00806E;
		}
	}
}
</style>
